export default function GetApp() {
  return (
    <a
      href="https://o2o.to/i/hOFYfB"
      className="select-none hover:text-[initial] bg-getAppGradient h-6 w-16 rounded-full text-center md:hidden flex items-center justify-center text-xs font-semibold text-[#080C0F]"
    >
      Get App
    </a>
  )
}
